import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Repertoire from '@/pages/Repertoire'
import About from '@/pages/About'
import Contact from '@/pages/Contact'
import Testimonials from '@/pages/Testimonials'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
			component: Home,
			meta: {
				displayDialog: false
			}
    },{
      path: '/repertoire',
      name: 'Repertoire',
      component: Repertoire
    },{
      path: '/about',
      name: 'About',
      component: About
    },{
      path: '/contact',
      name: 'Contact',
      component: Contact
    },{
      path: '/testimonials',
      name: 'Testimonials',
      component: Testimonials
		}
  ]
})
